/* eslint-disable react/prop-types */
import React from 'react';
import { useTheme } from 'styled-components';
import Icon from '../Icon';
import { tokens, orange, inkA } from '../tokens';

// Horizontal day-of-week filter. Chips are multi-select toggles (no selection
// means "all days"). Controlled — the parent owns the `value` array.
const DAYS = [
  { key: 1, label: 'Mon' },
  { key: 2, label: 'Tue' },
  { key: 3, label: 'Wed' },
  { key: 4, label: 'Thu' },
  { key: 5, label: 'Fri' },
  { key: 6, label: 'Sat' },
  { key: 0, label: 'Sun' },
];

const DayChipFilter = ({ value = [], onChange }) => {
  const theme = useTheme();
  const t = tokens(theme);

  const toggle = (day) => {
    if (typeof onChange !== 'function') return;
    const next = value.includes(day)
      ? value.filter((d) => d !== day)
      : [...value, day];
    onChange(next);
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap',
      }}
    >
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 7,
          minWidth: 52,
          fontSize: '12.5px',
          fontWeight: 800,
          letterSpacing: '0.9px',
          textTransform: 'uppercase',
          color: t.primary,
        }}
      >
        <Icon name="calendar" size={15} color={t.primary} strokeWidth={2.25} />
        Day
      </span>

      {DAYS.map((d) => {
        const on = value.includes(d.key);
        return (
          <button
            key={d.key}
            onClick={() => toggle(d.key)}
            style={{
              height: 34,
              padding: '0 15px',
              borderRadius: 10,
              fontSize: 13,
              fontWeight: 700,
              letterSpacing: '0.3px',
              cursor: 'pointer',
              background: on ? orange(0.12) : inkA(theme, 0.04),
              border: '1px solid ' + (on ? orange(0.55) : t.border),
              color: on ? t.primary : t.sub,
              transition:
                'background 140ms ease, border-color 140ms ease, color 140ms ease',
            }}
          >
            {d.label}
          </button>
        );
      })}

      {value.length > 0 && (
        <button
          onClick={() => typeof onChange === 'function' && onChange([])}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            height: 34,
            padding: '0 14px',
            borderRadius: 20,
            fontSize: 13,
            fontWeight: 700,
            letterSpacing: '0.3px',
            cursor: 'pointer',
            background: inkA(theme, 0.04),
            border: '1px solid ' + t.border,
            color: t.sub,
            transition:
              'background 140ms ease, border-color 140ms ease, color 140ms ease',
          }}
        >
          <Icon name="x" size={14} color={t.sub} strokeWidth={2.25} />
          Clear
        </button>
      )}
    </div>
  );
};

export default DayChipFilter;
